/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.601
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveHouseRentalInfo,
	getHouseRentalInfoCreateInit,
	getHouseRentalInfoEditInit,
	getHouseRentalInfoView,
	deleteHouseRentalInfo
} from '@api/lcf/HouseRentalInfo';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getHouseRentalInfoCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getHouseRentalInfoCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseRentalInfoEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseRentalInfoEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveHouseRentalInfo({}, HouseRentalInfo) {
			return new Promise((resolve, reject) => {
				saveHouseRentalInfo(HouseRentalInfo)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getHouseRentalInfoView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getHouseRentalInfoView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteHouseRentalInfo({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteHouseRentalInfo({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
